import { useSnackbar } from 'ui-components';
import InviteCreatorModal from '~/components/InviteCreatorModal/InviteCreatorModal';
import { useInviteCreator } from '~/hooks/api/useInviteCreator';
import { IUseUniqueDisclosureReturn } from '~/hooks/useUniqueDisclosure';

interface InviteCreatorModalContainerProps {
  inviteCreatorDisclosure: IUseUniqueDisclosureReturn;
  afterCreatorSubmit?: () => void;
}

// this component is used to make API calls, toast appropriatly and  handl the state of the modal.
export const InviteCreatorModalContainer: React.FC<
  InviteCreatorModalContainerProps
> = ({ inviteCreatorDisclosure, afterCreatorSubmit }) => {
  const snackbar = useSnackbar();
  const mutation = useInviteCreator();

  const handleInviteCreatorModalSubmit: (option: {
    email: string;
    handle?: string;
    message?: string;
  }) => Promise<void> = async ({ email, handle, message }) => {
    mutation.mutate(
      { email, handle, message },
      {
        onSuccess: () => {
          snackbar.success({
            description: `Invitation sent: We've sent the invitation to ${email}`,
            duration: 9000,
            isCloseable: true,
          });
          afterCreatorSubmit?.();
          inviteCreatorDisclosure.onClose();
        },
        onError: (error) => {
          snackbar.error({
            description: `Inviting creator failed: ${error.message}`,
            duration: 9000,
            isCloseable: true,
          });
        },
      },
    );
  };
  return (
    <InviteCreatorModal
      key={inviteCreatorDisclosure.modalKey}
      isOpen={inviteCreatorDisclosure.isOpen}
      onCancel={inviteCreatorDisclosure.onClose}
      onSubmit={handleInviteCreatorModalSubmit}
    />
  );
};
